import ShopArticlesListResourcePagingResultModel from '../../generated/types/model/resource/ShopArticlesListResourcePagingResultModel';

export default class ShopArticlesListResourcePagingResultViewModel extends ShopArticlesListResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
